// extracted by mini-css-extract-plugin
export var blue = "_38-f";
export var brand = "_38-b";
export var darkGrey = "_38-e";
export var disabled = "_38-4";
export var disabledSubtle = "_38-5";
export var error = "_38-6";
export var green = "_38-g";
export var grey = "_38-d";
export var icon = "_38-0";
export var inherit = "_38-a";
export var lightGrey = "_38-c";
export var orange = "_38-i";
export var pink = "_38-k";
export var primary = "_38-1";
export var purple = "_38-l";
export var red = "_38-j";
export var secondary = "_38-2";
export var success = "_38-9";
export var tertiary = "_38-3";
export var warning = "_38-7";
export var warningSecondary = "_38-8";
export var white = "_38-m";
export var yellow = "_38-h";